<template>
  <Container>
    <div class="max-w-prose">
      <ContentHeader
        :title="title"
        :lead="
          $texts(
            'passwordResetText',
            'Geben Sie Ihrer 7-stellige Mitglieder- bzw. FPH-Nummer oder E-Mail-Adresse an, um Ihr Passwort zurückzusetzen.',
          )
        "
      />
      <PasswordResetForm />
    </div>
  </Container>
</template>

<script lang="ts" setup>
const { $texts } = useNuxtApp()

const title = computed(() => {
  return $texts('passwordReset', 'Passwort zurücksetzen')
})

definePageMeta({
  name: 'user-password',
  middleware: ['anonymous-only'],
})

useHead({
  title,
})

setBreadcrumbLinks()
useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PagePharmasuisseUserPassword',
}
</script>
